<template>
  <div>
    <div
      class="pagination-div"
      v-if="
        !keyword &&
        !toDate &&
        !fromDate &&
        !(valueFilterList.length == 1 && valueFilterList.includes('cancelled')) &&
        !(valueFilterList.length == 1 && valueFilterList.includes('not-cancelled'))
      "
    >
      <v-btn
        class="ma-2 page-arrow-size"
        outlined
        color="#707070"
        @click="changePage('prev')"
        :disabled="pageCount === 1 || loading"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn class="page-count-size" outlined color="#c9242b">
        {{ pageCount }}
      </v-btn>
      <v-btn
        class="ma-2 page-arrow-size"
        outlined
        color="#707070"
        @click="changePage('next')"
        :disabled="emptyList || loading || checkFinalPage(summaryAll)"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <span v-if="summaryAll">{{ showTotalPage(summaryAll) }}</span>
    </div>
    <!-- {{ listOrigin.length }} -->
    <!-- fromDate:: {{ fromDate }} -->
    <!-- toDate::     {{ toDate }} -->
    <div
      v-if="
        (keyword ||
        toDate ||
        fromDate ||
        (valueFilterList.length == 1 && valueFilterList.includes('cancelled')) ||
        (valueFilterList.length == 1 && valueFilterList.includes('not-cancelled'))) &&
          listOrigin.length >= 10 &&
          !loading
      "
      class="tw-text-center tw-mb-6"
    >
      <v-btn
        text
        color="#6ec39b"
        type="button"
        class="btn-submit"
        @click="changePage('next')"
      >
        <b
          >โหลดข้อมูลเพิ่มเติม
          <v-icon small>mdi-arrow-down</v-icon>
        </b>
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: mapState({
    pageCount(state) {
      return state[this.collectionName].page;
    },
    keyword(state) {
      return state[this.collectionName].keyword;
    },
    fromDate(state) {
      return state[this.collectionName].fromDate;
    },
    toDate(state) {
      return state[this.collectionName].toDate;
    },
    listOrigin(state) {
      return state[this.collectionName].listOrigin;
    },
    emptyList(state) {
      return state[this.collectionName].emptyList;
    },
    loading(state) {
      return state[this.collectionName].loading;
    },
    orderBySelect(state) {
      return state[this.collectionName].orderBySelect;
    },
    summaryAll(state) {
      return state[this.collectionName].summaryAll;
    },
    showPaginationTemplate(state) {
      return state[this.collectionName].showPaginationTemplate;
    },
    valueFilterList: (state) => state.docs.valueFilterList,
    pageLimitAutoChange: (state) => state.user.pageLimitAutoChange,
  }),
  created() {
    this.getPageLimit();
    this.pageAll();
    this.checkPageAll();
  },
  beforeDestroy() {
    this.$store.dispatch("docs/getSummaryAllUnsubscribe");
  },
  props: ["collectionName"],
  methods: {
    query: function (isNextPage) {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch(this.collectionName + "/getList", {
          id: companyId,
          keyword: this.keyword,
          isNextPage: isNextPage,
        });
      }
    },
    changePage: function (page) {
      this.$store
        .dispatch(this.collectionName + "/updatePage", {
          page: page === "next" ? this.pageCount + 1 : this.pageCount - 1,
        })
        .then(() => {
          this.query(page === "next");
        });
    },
    pageAll: function () {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch(`${this.collectionName}/getSummaryAll`, {
        companyId,
      });
    },
    // จำนวนแถวที่หน้านี้โหลดมาได้จริง — บาง store ที่ใช้ pagination ตัวนี้ (purchase,
    // docsDownloadedByCompany) ไม่มี listOrigin เลย ต้องกัน undefined ไว้
    rowsOnPage: function () {
      return this.listOrigin ? this.listOrigin.length : 0;
    },
    calTotalPage: function (summaryAll) {
      let total = this.checkPageAll(summaryAll);
      if (total === null) return null;
      return Math.ceil(total / this.limitPage);
    },
    showTotalPage: function (summaryAll) {
      let total = this.checkPageAll(summaryAll);
      let startRow = (this.pageCount - 1) * this.limitPage + 1;
      // แท็บที่ไม่มีตัวนับ — บอกได้แค่ว่าหน้านี้คือแถวที่เท่าไหร่ถึงเท่าไหร่
      // เขียน "จาก 0" ทั้งที่มีข้อมูลอยู่เต็มตาราง ทำให้คนอ่านเข้าใจผิดว่าไม่มีเอกสาร
      if (total === null) {
        let lastRow = startRow + this.rowsOnPage() - 1;
        return lastRow < startRow ? "" : `${startRow} - ${lastRow}`;
      }
      let endRow = this.pageCount * this.limitPage;
      if (endRow > total) endRow = total;
      return `${startRow} - ${endRow}  ${
        this.keyword ? "จาก อีกจำนวนหนื่ง" : "จาก " + total
      }`;
    },
    checkPageAll: function (summaryAll) {
      if (summaryAll) {
        let total = 0;
        let nameRoute = this.$route.name;
        let keyValue = {
          "Company.Documents": "countsDocsAll",
          "Company.Documents.TX": "countsDocsType1",
          "Company.Documents.DR": "countsDocsType3",
          "Company.Documents.CR": "countsDocsType4",
          "Company.Documents.RE": "countsDocsType5",
          "Company.Documents.AB": "countsDocsType2",
          "Company.Documents.RT": "countsDocsType6",
          "Company.DocumentsSaleOnline": "countsSaleOrdersAll",
          "Company.WithholdingTax": "countsDocsThaiSmartTaxAll",
        };
        let resultField = keyValue[nameRoute];
        // ไม่ใช่ทุกแท็บจะมีตัวนับของตัวเอง (ใบแจ้งยกเลิกไม่มี) — คืน null ไปบอกว่า
        // "ไม่รู้ยอดรวม" ไม่ใช่ 0 เพราะ 0 แปลว่าไม่มีเอกสาร แล้วปุ่มหน้าถัดไปจะถูกปิด
        if (!resultField) {
          return null;
        }
        total = summaryAll[resultField] || 0;
        if (this.valueFilterList.length === 1) {
          let downloaded = this.valueFilterList.includes("@DownloadedXml");
          if (downloaded) {
            resultField = resultField + "DownloadedXml";
            total = summaryAll[resultField] || 0;
          } else {
            total =
              summaryAll[resultField] -
              (summaryAll[resultField + "DownloadedXml"] || 0);
          }
        }
        return total;
      }
      return 0;
    },
    getPageLimit: function () {
      let pageLimit = localStorage.getItem("pageLimit");
      if (pageLimit === "auto") {
        pageLimit = parseInt(localStorage.getItem("pageLimitAuto")) || 10;
      } else {
        pageLimit = parseInt(pageLimit) || 10;
      }
      this.limitPage = pageLimit;
    },
    checkFinalPage: function (summaryAll) {
      let totalPage = this.calTotalPage(summaryAll);
      // ไม่รู้ยอดรวมของแท็บนี้ ก็เดินหน้าต่อได้ตราบใดที่หน้านี้โหลดมาเต็มลิมิต —
      // วิธีเดียวกับปุ่ม "โหลดข้อมูลเพิ่มเติม" ของโหมดค้นหาที่ก็ไม่รู้ยอดรวมเหมือนกัน
      if (totalPage === null) {
        return this.rowsOnPage() < this.limitPage;
      }
      return this.pageCount >= totalPage;
    },
  },
  data: function () {
    return {
      limitPage: 1,
    };
  },
  watch: {
    pageLimitAutoChange: {
      handler: function () {
        this.getPageLimit();
      },
    },
  },
};
</script>

<style lang="scss">
.v-application .v-pagination__item.primary {
  background-color: white !important;
  border: solid 1px #c9242b !important;
  color: #c9242b !important;
}
.pagination-div {
  float: left;
}
.page-count-size {
  min-width: 50px !important;
}
.page-arrow-size {
  min-width: 60px !important;
}
</style>
